module.exports = __webpack_public_path__ + "img/offline.0226e648.png";